import { Divider, Typography } from 'antd';
import styled from 'styled-components';

export const AssignmentBlock = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px 16px;
  & + & {
    margin-top: 12px;
  }
`;

export const BlockDivider = styled(Divider)`
  margin: 10px 0;
`;

export const StatusTag = styled(Typography.Text)<{ $color: string }>`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding: 5px 10px 5px 15px;
  border-radius: 3px;

  ::before {
    position: absolute;
    content: '';
    left: 2px;
    top: calc(50% - 3px);
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
  }
`;
